import { createFileRoute } from '@tanstack/react-router'

import { LearnpathsCreatorContent } from '@/learnpaths-creator/components/LearnpathsCreatorContent/LearnpathsCreatorContent'

export const Route = createFileRoute(
  '/company/learnpaths/add/elements/$learnpathId',
)({
  component: LearnpathsCreatorContent,
})
